// removed by extract-text-webpack-plugin
module.exports = {"infoTable__battlePayments":"ConstructReserveTooltip_infoTable__battlePayments--11nSZ","infoTableBattlePayments":"ConstructReserveTooltip_infoTable__battlePayments--11nSZ","infoTable__additionalBriefing":"ConstructReserveTooltip_infoTable__additionalBriefing--3UjF3","infoTableAdditionalBriefing":"ConstructReserveTooltip_infoTable__additionalBriefing--3UjF3"};


//////////////////
// WEBPACK FOOTER
// ./containers/Construct/components/ConstructReserveTooltip/ConstructReserveTooltip.scss
// module id = 2162
// module chunks = 11